"use client"

import React from "react"
import { useState, useEffect } from "react"
import dayjs, { Dayjs } from "dayjs"
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonRefresher, IonRefresherContent, useIonViewWillEnter } from "@ionic/react"
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  MenuItem,
  Button,
  Card,
  CardContent,
  Grid,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  Divider,
  Alert,
  CircularProgress,
  Tooltip,
  TablePagination,
  LinearProgress,
  Snackbar,
  TableFooter,
  Avatar,
} from "@mui/material"
import {
  Search,
  FilterList,
  Download,
  Visibility,
  Close,
  AttachMoney,
  Receipt,
  Person,
  CheckCircle,
  Warning,
  Error as ErrorIcon,
  Info as InfoIcon,
  Business,
  Category,
  ClearAll,
} from "@mui/icons-material"
import { DatePicker } from "@mui/x-date-pickers"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"

import { fetchOrderDetails_items, fetchSalesData_withdate_staffId_paymentMethodCall, getManagersOrders_reciept, getManagersOrders_reciept_withdate } from "../../../api/reports/reports"
import { getStaffList_saleapp } from "../../../api/users/user"
 import { formatCurrencyN } from "../../../common/utils_t"
import { getTlocations_production_centre } from "../../../api/stock-transfer/stock-transfer"
import { getCategories } from "../../../api/products/product" // Add this import
import { MenuButton } from "../../../components/Menu"

// Define interfaces for your API response
interface ApiOrderItem {
  id: number;
  order_id: string;
  product_id: string;
  quantity: number;
  price: string;
  total_amount: string;
  created_at: string;
  updated_at: string | null;
  deleted_at: string | null;
  status: string;
  last_updated: string;
  category_id: string;
  branch_id: string;
  business_id: string;
  description: string;
  cost_price: string;
  member_id: string;
  date_bags: string;
  date_bags_copy: string;
  checked_in: number;
  checked_out: number;
  month_id: string;
  roleID: string;
  check_in_date: string;
  check_out_date: string;
  checked_out_by: string;
  reversed_at: string;
  reversed_by: string;
  name: string;
}

interface ApiOrderDetailsResponse {
  status: boolean;
  message: string;
  data: {
    items: ApiOrderItem[];
    count: number;
    date_range: {
      applied: boolean;
      start_date: string;
      end_date: string;
    };
  };
}

interface SalesTransaction {
  order_id: string
  order_code: string
  order_date: string
  mode_of_payment: string
  payable_amount: string
  balance_due: string
  order_by: string
  order_status: string
  member_id: string
  member_name: string
  payment_status: string
  otp_status: string | null
  items: any[]
  tabBalance: number
  debtBalance: number
  walletDetails: number
  walletDetails_l: number
  amount_paid: string
  staffFullName?: string
  firstName?: string
  branch_id?: string
  transaction_category?: string // Add transaction_category field
}

interface SalesStats {
  total_sales: number
  total_orders: number
  average_order_value: number
  top_payment_method: string
  growth_percentage: number
  pending_orders: number
  completed_orders: number
}

interface Staff {
  staff_id: string
  staff_name: string
  user_id: string
  firstName: string
  lastName: string
  roleName: string
  branchName: string
}

interface Branch {
  branch_id: string;
  branch_name: string;
  business_id: string;
  location?: string;
  address?: string;
  phone?: string;
  email?: string;
  status?: string;
}

interface ProductCategory {
  category_id: string;
  name: string;
  description?: string;
  status?: string;
}

interface FilterState {
  startDate: Dayjs | null
  endDate: Dayjs | null
  paymentMethod: string
  department: string
  orderStatus: string
  paymentStatus: string
  staffId: string
  branchId: string
  categoryId: string // Add category filter
}

const ManagerSalesReportPage_R: React.FC = () => {
  const [transactions, setTransactions] = useState<SalesTransaction[]>([])
  const [filteredTransactions, setFilteredTransactions] = useState<SalesTransaction[]>([])
  const [salesStats, setSalesStats] = useState<SalesStats | null>(null)
  const [loading, setLoading] = useState(false)
  const [searchQuery, setSearchQuery] = useState("")
  const [showFilters, setShowFilters] = useState(false)
  const [showTransactionDetail, setShowTransactionDetail] = useState(false)
  const [selectedTransaction, setSelectedTransaction] = useState<SalesTransaction | null>(null)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(100)

  const [staffList, setStaffList] = useState<Staff[]>([])
  const [branches, setBranches] = useState<Branch[]>([])
  const [categories, setCategories] = useState<ProductCategory[]>([]) // Add categories state

  const [filters, setFilters] = useState<FilterState>({
    startDate: dayjs(),
    endDate: dayjs(),
    paymentMethod: "",
    department: "",
    orderStatus: "",
    paymentStatus: "",
    staffId: "",
    branchId: "",
    categoryId: "", // Add category to filters
  })

  const [myBalance_due, setMyBalance_due] = useState(0)
  const [myAmount_paid, setMyAmount_paid] = useState(0)
  const [myTotal, setMyTotal] = useState(0)

  const [loadingDetails, setLoadingDetails] = useState(false)
  const [orderDetails, setOrderDetails] = useState<ApiOrderDetailsResponse['data'] | null>(null)
  const [detailsError, setDetailsError] = useState<string | null>(null)
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState("")

  const paymentMethods = ["All", "cash", "card", "transfer", "mobile_money"]

  
  useEffect(() => {
    applyFilters()
  }, [transactions, searchQuery, filters])

  // Fetch branches data
  const fetchBranches = async () => {
    try {
      const response = await getTlocations_production_centre()
      console.log("Branches response:", response)
      setBranches(response.data.data || [])
    } catch (error) {
      console.error("Failed to fetch branches", error)
      setSnackbarMessage("Failed to fetch branches")
      setSnackbarOpen(true)
    }
  }

  // Fetch categories data
  const fetchCategories = async () => {
    try {
      const response = await getCategories()
      console.log("Categories response:", response)
      if (response.data) {
        setCategories(response.data)
      }
    } catch (error) {
      console.error("Failed to fetch categories", error)
      setSnackbarMessage("Failed to fetch categories")
      setSnackbarOpen(true)
    }
  }

  const fetchStaffData = async () => {
    try {
      const response = await getStaffList_saleapp()
      console.log({ staffResponse: response })
      if (response.data) {
        setStaffList(response.data)
      }
    } catch (error) {
      console.error("Error fetching staff data:", error)
    }
  }

  const formatDateYMD = (date: Dayjs | null) => {
    if (!date || !date.isValid()) {
      return dayjs().format('YYYY-MM-DD')
    }
    return date.format('YYYY-MM-DD')
  }

  // Updated filter functions to include categoryId
  const liveFilter = ({ startDate, endDate }: { startDate: Dayjs | null, endDate: Dayjs | null }) => {
    if (!startDate || !endDate) return
    
    const formattedStart = formatDateYMD(startDate)
    const formattedEnd = formatDateYMD(endDate)

    fetchSalesData_withdate(formattedStart, formattedEnd, filters.branchId)
  }

  const liveFilterStaffId = ({ startDate, endDate, staffId }: { startDate: Dayjs | null, endDate: Dayjs | null, staffId: string }) => {
    if (!startDate || !endDate) return
    
    const formattedStart = formatDateYMD(startDate)
    const formattedEnd = formatDateYMD(endDate)

    fetchSalesData_withdate_staffId(formattedStart, formattedEnd, staffId, filters.branchId)
  }

  const liveFilterStaffId_paymentMethod = ({ startDate, endDate, staffId, paymentMethod }: { startDate: Dayjs | null, endDate: Dayjs | null, staffId: string, paymentMethod: string }) => {
    if (!startDate || !endDate) return
    
    const formattedStart = formatDateYMD(startDate)
    const formattedEnd = formatDateYMD(endDate)

    fetchSalesData_withdate_staffId_paymentMethod(formattedStart, formattedEnd, staffId, paymentMethod, filters.branchId)
  }

  // Fetch order details from API endpoint
  const fetchOrderDetails = async (orderId: string, branchId: string) => {
    setLoadingDetails(true)
    setDetailsError(null)
    setOrderDetails(null)

    try {
      const startDateStr = formatDateYMD(filters.startDate)
      const endDateStr = formatDateYMD(filters.endDate)

      console.log("Fetching order details for:", {
        order_id: orderId,
        start_date: startDateStr,
        end_date: endDateStr,
        branch_id: branchId
      })

      const response = await fetchOrderDetails_items(orderId, startDateStr, endDateStr, branchId)
     

      if (response.status) {
         console.log({ response })
        setOrderDetails(response.data)
        setSnackbarMessage("Order details loaded successfully")
        setSnackbarOpen(true)
      } else {
        throw new Error(response.data.message || "Failed to load order details")
      }

    } catch (error) {
      console.error("Error fetching order details:", error)
      setDetailsError(error instanceof Error ? error.message : "Failed to load order details")
      setSnackbarMessage("Failed to load order details")
      setSnackbarOpen(true)
    } finally {
      setLoadingDetails(false)
    }
  }

  // Updated API calls to include branchId parameter
  const fetchSalesData_withdate_staffId_paymentMethod = async (start: string, end: string, staffId: string, paymentMethod: string, branchId: string = "") => {
    setLoading(true)
    try {
      const response = await fetchSalesData_withdate_staffId_paymentMethodCall(rowsPerPage, start, end, staffId, paymentMethod, branchId)
      console.log({ response })

      await fetchStaffData()

      let filteredByPaymentMethod = response.data.orders
      if (paymentMethod && paymentMethod !== "All") {
        filteredByPaymentMethod = filteredByPaymentMethod.filter((txn: SalesTransaction) => txn.mode_of_payment === paymentMethod)
      }

      setTransactions(filteredByPaymentMethod)
      setMyBalance_due(response.data.balance_due)
      setMyAmount_paid(response.data.amount_paid)
      setMyTotal(response.data.mytotal)

      const totalSales = filteredByPaymentMethod?.reduce((sum: number, txn: SalesTransaction) => sum + Number.parseFloat(txn.payable_amount), 0)
      const completedOrders = filteredByPaymentMethod?.filter((txn: SalesTransaction) => txn.order_status === "COMPLETED").length
      const pendingOrders = filteredByPaymentMethod?.filter((txn: SalesTransaction) => txn.order_status === "PENDING").length

      setSalesStats({
        total_sales: totalSales,
        total_orders: filteredByPaymentMethod?.length,
        average_order_value: totalSales / filteredByPaymentMethod?.length,
        top_payment_method: "cash",
        growth_percentage: 12.5,
        pending_orders: pendingOrders,
        completed_orders: completedOrders,
      })

    } catch (error) {
      console.error("Error fetching sales data:", error)
    } finally {
      setLoading(false)
    }
  }

  const fetchSalesData_withdate_staffId = async (start: string, end: string, staffId: string, branchId: string = "") => {
    setLoading(true)
    try {
      const response = await getManagersOrders_reciept_withdate(rowsPerPage, start, end, staffId, branchId)
      console.log({ response })

      await fetchStaffData()

      setTransactions(response.data.orders)
      setMyBalance_due(response.data.balance_due)
      setMyAmount_paid(response.data.amount_paid)
      setMyTotal(response.data.mytotal)

      const totalSales = response.data.orders?.reduce((sum: number, txn: SalesTransaction) => sum + Number.parseFloat(txn.payable_amount), 0)
      const completedOrders = response.data.orders?.filter((txn: SalesTransaction) => txn.order_status === "COMPLETED").length
      const pendingOrders = response.data.orders?.filter((txn: SalesTransaction) => txn.order_status === "PENDING").length

      setSalesStats({
        total_sales: totalSales,
        total_orders: response.data.orders?.length,
        average_order_value: totalSales / response.data.orders?.length,
        top_payment_method: "cash",
        growth_percentage: 12.5,
        pending_orders: pendingOrders,
        completed_orders: completedOrders,
      })

    } catch (error) {
      console.error("Error fetching sales data:", error)
    } finally {
      setLoading(false)
    }
  }

  const fetchSalesData_withdate = async (start: string, end: string, branchId: string = "") => {
    setLoading(true)
    try {
      const response = await getManagersOrders_reciept_withdate(rowsPerPage, start, end, "all", branchId)
      console.log({ response })

      await fetchStaffData()

      setTransactions(response.data.orders)
      setMyBalance_due(response.data.balance_due)
      setMyAmount_paid(response.data.amount_paid)
      setMyTotal(response.data.mytotal)

      const totalSales = response.data.orders?.reduce((sum: number, txn: SalesTransaction) => sum + Number.parseFloat(txn.payable_amount), 0)
      const completedOrders = response.data.orders?.filter((txn: SalesTransaction) => txn.order_status === "COMPLETED").length
      const pendingOrders = response.data.orders?.filter((txn: SalesTransaction) => txn.order_status === "PENDING").length

      setSalesStats({
        total_sales: totalSales,
        total_orders: response.data.orders?.length,
        average_order_value: totalSales / response.data.orders?.length,
        top_payment_method: "cash",
        growth_percentage: 12.5,
        pending_orders: pendingOrders,
        completed_orders: completedOrders,
      })

    } catch (error) {
      console.error("Error fetching sales data:", error)
    } finally {
      setLoading(false)
    }
  }

  const fetchSalesData = async () => {
    setLoading(true)
    try {
      const response = await getManagersOrders_reciept(rowsPerPage)
      console.log({ response })

      await fetchStaffData()
      await fetchBranches()
      await fetchCategories() // Fetch categories

      setTransactions(response.data.orders)
      setMyBalance_due(response.data.balance_due)
      setMyAmount_paid(response.data.amount_paid)
      setMyTotal(response.data.mytotal)

      const totalSales = response.data.orders?.reduce((sum: number, txn: SalesTransaction) => sum + Number.parseFloat(txn.payable_amount), 0)
      const completedOrders = response.data.orders?.filter((txn: SalesTransaction) => txn.order_status === "COMPLETED").length
      const pendingOrders = response.data.orders?.filter((txn: SalesTransaction) => txn.order_status === "PENDING").length

      setSalesStats({
        total_sales: totalSales,
        total_orders: response.data.orders?.length,
        average_order_value: totalSales / response.data.orders?.length,
        top_payment_method: "cash",
        growth_percentage: 12.5,
        pending_orders: pendingOrders,
        completed_orders: completedOrders,
      })

    } catch (error) {
      console.error("Error fetching sales data:", error)
    } finally {
      setLoading(false)
    }
  }

  const applyFilters = () => {
    let filtered = transactions ? transactions : []

    if (searchQuery) {
      filtered = filtered?.filter(
        (transaction) =>
          transaction.order_code.toLowerCase().includes(searchQuery.toLowerCase()) ||
          transaction.member_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          transaction.order_id.toLowerCase().includes(searchQuery.toLowerCase()),
      )
    }

    if (filters.startDate && filters.endDate) {
      const start = filters.startDate.toDate()
      start.setHours(0, 0, 0, 0)

      const end = filters.endDate.toDate()
      end.setHours(23, 59, 59, 999)

      filtered = filtered?.filter((transaction) => {
        const transactionDate = new Date(transaction.order_date)
        return transactionDate >= start && transactionDate <= end
      })
    }

    if (filters.paymentMethod && filters.paymentMethod !== "All") {
      filtered = filtered?.filter((transaction) => transaction.mode_of_payment === filters.paymentMethod)
    }

    if (filters.staffId && filters.staffId !== "All") {
      filtered = filtered?.filter((transaction) => transaction.order_by === filters.staffId)
    }

    // Apply branch filter
    if (filters.branchId && filters.branchId !== "") {
      filtered = filtered?.filter((transaction) => transaction.branch_id === filters.branchId)
    }

    // Apply category filter
    if (filters.categoryId && filters.categoryId !== "") {
      filtered = filtered?.filter((transaction) => transaction.transaction_category === filters.categoryId)
    }

    setFilteredTransactions(filtered)
  }

  const handleFilterChange = (field: keyof FilterState, value: any) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  // Updated clearFilters to include categoryId
  const clearFilters = () => {
    setFilters({
      startDate: dayjs(),
      endDate: dayjs(),
      paymentMethod: "",
      department: "",
      orderStatus: "",
      paymentStatus: "",
      staffId: "",
      branchId: "",
      categoryId: "",
    })
    setSearchQuery("")
  }

  const viewTransactionDetail = async (transaction: SalesTransaction) => {
    console.log("Opening transaction details for:", transaction)
    setSelectedTransaction(transaction)
    setShowTransactionDetail(true)
    
    await fetchOrderDetails(transaction.order_id, transaction.branch_id || "")
  }

  const closeTransactionDetail = () => {
    setShowTransactionDetail(false)
    setSelectedTransaction(null)
    setOrderDetails(null)
    setDetailsError(null)
  }

  const getOrderStatusColor = (status: string) => {
    switch (status.toUpperCase()) {
      case "COMPLETED":
        return "success"
      case "PENDING":
        return "warning"
      case "CANCELLED":
        return "error"
      default:
        return "default"
    }
  }

  const formatCurrency = (amount: string | number) => {
    const numAmount = typeof amount === "string" ? Number.parseFloat(amount) : amount
    return new Intl.NumberFormat("en-NG", {
      style: "currency",
      currency: "NGN",
    }).format(numAmount)
  }

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString("en-NG", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
  }

  const exportData = () => {
    const headers = [
      "Order Code",
      "Date",
      "Staff Name",
      "Member Name",
      "Payment Method",
      "Amount",
      "Balance Due",
      "Order Status",
      "Branch ID",
      "Product Category",
    ]

    const csvContent = [
      headers.join(","),
      ...filteredTransactions.map((transaction) =>
        [
          transaction.order_code,
          transaction.order_date,
          `"${transaction.member_name}"`,
          transaction.mode_of_payment,
          transaction.payable_amount,
          transaction.balance_due,
          transaction.order_status,
          transaction.branch_id || "N/A",
          transaction.transaction_category || "N/A",
        ].join(","),
      ),
    ].join("\n")

    const blob = new Blob([csvContent], { type: "text/csv" })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = `sales-report-${new Date().toISOString().split("T")[0]}.csv`
    a.click()
    window.URL.revokeObjectURL(url)
  }

  useIonViewWillEnter(() => {
    fetchSalesData()
    fetchStaffData()
    fetchBranches()
    fetchCategories()
  })

  const paymentMethodTotals = filteredTransactions.reduce((acc: Record<string, number>, transaction) => {
    const { mode_of_payment, amount_paid } = transaction
    if (!acc[mode_of_payment]) {
      acc[mode_of_payment] = 0
    }
    acc[mode_of_payment] += Number(amount_paid)
    return acc
  }, {})

  const calculateOrderTotals = (items: ApiOrderItem[]) => {
    const totals = {
      grossSales: 0,
      totalCost: 0,
      totalQuantity: 0,
      totalAmount: 0,
    }

    items.forEach(item => {
      const quantity = parseFloat(item.quantity.toString())
      const price = parseFloat(item.price)
      const costPrice = parseFloat(item.cost_price || "0")
      const totalAmount = parseFloat(item.total_amount)

      totals.grossSales += quantity * price
      totals.totalCost += quantity * costPrice
      totals.totalQuantity += quantity
      totals.totalAmount += totalAmount
    })

    return totals
  }

  // Handle branch change with data refresh
  const handleBranchChange = (branchId: string) => {
    handleFilterChange("branchId", branchId)
    
    if (filters.startDate && filters.endDate) {
      const formattedStart = formatDateYMD(filters.startDate)
      const formattedEnd = formatDateYMD(filters.endDate)
      
      fetchSalesData_withdate(formattedStart, formattedEnd, branchId)
    }
  }

  // Handle category change
  const handleCategoryChange = (categoryId: string) => {
    handleFilterChange("categoryId", categoryId)
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <IonPage className="pushDown">
        <IonHeader>
          <IonToolbar>  <MenuButton/>
            <IonTitle>Manager Sales Receipt</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent>
          <IonRefresher
            slot="fixed"
            onIonRefresh={(e) => {
              fetchSalesData().finally(() => e.detail.complete())
            }}
          >
            <IonRefresherContent />
          </IonRefresher>

          <Box sx={{ p: 2 }}>
            {/* Sales Statistics Cards */}
            {salesStats && (
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={6} md={3}>
                  <Card sx={{ bgcolor: "primary.light", color: "white" }}>
                    <CardContent sx={{ textAlign: "center", py: 2 }}>
                      <AttachMoney sx={{ fontSize: 40, mb: 1 }} />
                      <Typography variant="h6" sx={{ fontSize: "0.9rem" }}>
                        Total Sales
                      </Typography>
                      <Typography variant="h5" sx={{ fontWeight: "bold", fontSize: "1.2rem" }}>
                        {formatCurrencyN(Number(myTotal))}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Card sx={{ bgcolor: "success.light", color: "white" }}>
                    <CardContent sx={{ textAlign: "center", py: 2 }}>
                      <Receipt sx={{ fontSize: 40, mb: 1 }} />
                      <Typography variant="h6" sx={{ fontSize: "0.9rem" }}>
                        Total Deposit
                      </Typography>
                      <Typography variant="h5" sx={{ fontWeight: "bold", fontSize: "1.2rem" }}>
                        {formatCurrencyN(Number(myAmount_paid))}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Card sx={{ bgcolor: "warning.light", color: "white" }}>
                    <CardContent sx={{ textAlign: "center", py: 2 }}>
                      <Warning sx={{ fontSize: 40, mb: 1 }} />
                      <Typography variant="h6" sx={{ fontSize: "0.9rem" }}>
                        Total Debt
                      </Typography>
                      <Typography variant="h5" sx={{ fontWeight: "bold", fontSize: "1.2rem" }}>
                        {formatCurrencyN(Number(myBalance_due))}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Card sx={{ bgcolor: "info.light", color: "white" }}>
                    <CardContent sx={{ textAlign: "center", py: 2 }}>
                      <CheckCircle sx={{ fontSize: 40, mb: 1 }} />
                      <Typography variant="h6" sx={{ fontSize: "0.9rem" }}>
                        Total Orders
                      </Typography>
                      <Typography variant="h5" sx={{ fontWeight: "bold", fontSize: "1.2rem" }}>
                        {salesStats.total_orders}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            )}

            {/* Search and Filter Controls */}
            <Paper sx={{ p: 2, mb: 2 }}>
              <Box sx={{ display: "flex", gap: 2, alignItems: "center", mb: 2 }}>
                <TextField
                  fullWidth
                  placeholder="Search by order code, member name, or order ID..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  InputProps={{
                    startAdornment: <Search sx={{ mr: 1, color: "text.secondary" }} />,
                  }}
                  size="small"
                />
                <Button variant="outlined" startIcon={<FilterList />} onClick={() => setShowFilters(!showFilters)}>
                  Filters
                </Button>
                <Button variant="outlined" startIcon={<Download />} onClick={exportData}>
                  Export
                </Button>
                <Button variant="outlined" startIcon={<ClearAll />} onClick={clearFilters} color="secondary">
                  Clear Filters
                </Button>
              </Box>

              {/* Filter Panel */}
              {showFilters && (
                <Box sx={{ borderTop: 1, borderColor: "divider", pt: 2 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={2}>
                      <DatePicker
                        label="Start Date"
                        value={filters.startDate}
                        onChange={(date) => {
                          handleFilterChange("startDate", date)
                          liveFilter({ startDate: date, endDate: filters.endDate })
                        }}
                        slotProps={{ textField: { size: 'small', fullWidth: true } }}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <DatePicker
                        label="End Date"
                        value={filters.endDate}
                        onChange={(date) => {
                          handleFilterChange("endDate", date)
                          liveFilter({ startDate: filters.startDate, endDate: date })
                        }}
                        slotProps={{ textField: { size: 'small', fullWidth: true } }}
                      />
                    </Grid>
                    
                    {/* Branch Filter */}
                    <Grid item xs={12} md={2}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Branch</InputLabel>
                        <Select
                          value={filters.branchId}
                          label="Branch"
                          onChange={(e) => handleBranchChange(e.target.value)}
                          startAdornment={
                            <Business sx={{ mr: 1, color: "text.secondary", fontSize: 16 }} />
                          }
                        >
                          <MenuItem value="">
                            <Typography sx={{ fontWeight: 600, color: "text.secondary", fontSize: "0.9rem" }}>
                              All Branches
                            </Typography>
                          </MenuItem>
                          {branches.map((branch) => (
                            <MenuItem key={branch.branch_id} value={branch.branch_id}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Business sx={{ fontSize: 16, color: "text.secondary" }} />
                                <Typography>
                                  {branch.name}
                                </Typography>
                              </Box>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    {/* Category Filter */}
                    <Grid item xs={12} md={2}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Product Category</InputLabel>
                        <Select
                          value={filters.categoryId}
                          label="Product Category"
                          onChange={(e) => handleCategoryChange(e.target.value)}
                          startAdornment={
                            <Category sx={{ mr: 1, color: "text.secondary", fontSize: 16 }} />
                          }
                        >
                          <MenuItem value="">
                            <Typography sx={{ fontWeight: 600, color: "text.secondary", fontSize: "0.9rem" }}>
                              All Categories
                            </Typography>
                          </MenuItem>
                          {categories.map((category) => (
                            <MenuItem key={category.category_id} value={category.category_id}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Category sx={{ fontSize: 16, color: "text.secondary" }} />
                                <Typography>
                                  {category.name}
                                </Typography>
                              </Box>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={2}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Staff</InputLabel>
                        <Select
                          value={filters.staffId}
                          label="Staff"
                          onChange={(e) => {
                            handleFilterChange("staffId", e.target.value)
                            liveFilterStaffId({ startDate: filters.startDate, endDate: filters.endDate, staffId: e.target.value })
                          }}
                        >
                          <MenuItem value="">
                            <Typography sx={{ fontWeight: 600, color: "text.secondary", fontSize: "0.9rem" }}>
                              All Staff
                            </Typography>
                          </MenuItem>
                          {staffList
                            ?.filter(
                              (staff) =>
                                staff.firstName?.trim() || staff.lastName?.trim()
                            )
                            .map((staff) => (
                              <MenuItem
                                key={staff.user_id}
                                value={staff.user_id}
                                sx={{
                                  py: 1.2,
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                }}
                              >
                                <Avatar
                                  sx={{
                                    width: 36,
                                    height: 36,
                                    fontSize: "0.9rem",
                                    bgcolor: "primary.main",
                                  }}
                                >
                                  {staff.firstName?.charAt(0)}
                                  {staff.lastName?.charAt(0)}
                                </Avatar>
                                <Box>
                                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, lineHeight: 1.2 }}>
                                    <Typography sx={{ fontWeight: 600 }}>
                                      {staff.firstName} {staff.lastName}
                                    </Typography>
                                    <Typography sx={{ fontWeight: 600, fontSize: "0.8rem", color: "error.main", bgcolor: "lemonchiffon", px: 0.8, py: 0.2, borderRadius: "6px" }}>
                                      {staff.roleName}
                                    </Typography>
                                  </Box>
                                  <Typography variant="caption" sx={{ color: "text.secondary" }}>
                                    {staff.branchName}
                                  </Typography>
                                </Box>
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={2}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Payment Method</InputLabel>
                        <Select
                          value={filters.paymentMethod}
                          label="Payment Method"
                          onChange={(e) => {
                            handleFilterChange("paymentMethod", e.target.value)
                            liveFilterStaffId_paymentMethod({ startDate: filters.startDate, endDate: filters.endDate, staffId: filters.staffId, paymentMethod: e.target.value })
                          }}
                        >
                          {paymentMethods.map((method) => (
                            <MenuItem key={method} value={method === "All" ? "" : method}>
                              {method}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Box>
              )}
            </Paper>

            {/* Results Summary with Branch and Category Info */}
            <Alert severity="info" sx={{ mb: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography>
                  Showing {filteredTransactions?.length} of {transactions?.length} orders
                  {filters.branchId && (
                    <span>
                      {" "}in branch: {
                        branches.find(b => b.branch_id === filters.branchId)?.name || filters.branchId
                      }
                    </span>
                  )}
                  {filters.categoryId && (
                    <span>
                      {" "}in category: {
                        categories.find(c => c.category_id === filters.categoryId)?.name || filters.categoryId
                      }
                    </span>
                  )}
                </Typography>
              </Box>
            </Alert>

            {/* Transactions Table */}
            <TableContainer
              component={Paper}
              sx={{
                overflowX: "auto",
                "&::-webkit-scrollbar": {
                  height: 8,
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "#f1f1f1",
                  borderRadius: 4,
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#c1c1c1",
                  borderRadius: 4,
                  "&:hover": {
                    backgroundColor: "#a8a8a8",
                  },
                },
              }}
            >
              <Table sx={{ minWidth: 1200 }}>
                <TableHead>
                  <TableRow sx={{ bgcolor: "grey.100" }}>
                    <TableCell sx={{ minWidth: 150, whiteSpace: "nowrap" }}>Order Code</TableCell>
                    <TableCell sx={{ minWidth: 150, whiteSpace: "nowrap" }}>Date</TableCell>
                    <TableCell sx={{ minWidth: 150, whiteSpace: "nowrap" }}>Staff</TableCell>
                    <TableCell sx={{ minWidth: 150, whiteSpace: "nowrap" }}>Member</TableCell>
                    <TableCell sx={{ minWidth: 120, whiteSpace: "nowrap" }}>Payment Method</TableCell>
                    <TableCell sx={{ minWidth: 120, whiteSpace: "nowrap" }}>Branch</TableCell>
                    <TableCell sx={{ minWidth: 120, whiteSpace: "nowrap" }}>Product Category</TableCell>
                    <TableCell align="right" sx={{ minWidth: 120, whiteSpace: "nowrap" }}>
                      Amount
                    </TableCell>
                    <TableCell align="right" sx={{ minWidth: 120, whiteSpace: "nowrap" }}>
                      Balance Due
                    </TableCell>
                    <TableCell align="center" sx={{ minWidth: 100, whiteSpace: "nowrap" }}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center" sx={{ py: 4 }}>
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : filteredTransactions?.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center" sx={{ py: 4 }}>
                        <Typography variant="body1" color="text.secondary">
                          No orders found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    <React.Fragment>
                      {filteredTransactions
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((transaction) => (
                          <TableRow
                            key={transaction.order_id}
                            sx={{
                              "&:nth-of-type(even)": { bgcolor: "grey.50" },
                              "&:hover": { bgcolor: "action.hover" },
                              cursor: "pointer"
                            }}
                            onClick={() => viewTransactionDetail(transaction)}
                          >
                            <TableCell sx={{ whiteSpace: "nowrap" }}>
                              <Typography variant="body2" sx={{ fontWeight: "bold", color: "primary.main" }}>
                                {transaction.order_code}
                              </Typography>
                            <Typography
  variant="body2"
  sx={{
    fontWeight: 600,
    cursor: "pointer",
    display: "inline-block",
    background: "linear-gradient(90deg, #1976d2, #9c27b0, #ef6c00)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateX(4px)",
      textDecoration: "underline",
      opacity: 0.85,
    },
  }}
>
  (click here to view order breakdown)
</Typography>

                            </TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap" }}>
                              <Typography variant="body2">{formatDate(transaction.order_date)}</Typography>
                            </TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap" }}>
                              <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Person sx={{ mr: 1, fontSize: 16, color: "text.secondary" }} />
                                <Typography variant="body2">{transaction.staffFullName}</Typography>
                              </Box>
                            </TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap" }}>
                              <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Person sx={{ mr: 1, fontSize: 16, color: "text.secondary" }} />
                                <Typography variant="body2">{transaction.firstName}</Typography>
                              </Box>
                            </TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap" }}>
                              <Chip label={transaction.mode_of_payment} size="small" color="secondary" />
                            </TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap" }}>
                              <Typography variant="body2" color="text.secondary">
                                {transaction.branch_id ? 
                                  branches.find(b => b.branch_id === transaction.branch_id)?.name || 
                                  transaction.branch_id.substring(0, 8) + "..." : 
                                  "N/A"}
                              </Typography>
                            </TableCell>
                            <TableCell sx={{ whiteSpace: "nowrap" }}>
                              {transaction.transaction_category ? (
                                <Chip 
                                  label={categories.find(c => c.category_id === transaction.transaction_category)?.name || 
                                    transaction.transaction_category.substring(0, 8) + "..."}
                                  size="small" 
                                  color="primary"
                                  variant="outlined"
                                />
                              ) : (
                                <Typography variant="body2" color="text.secondary">
                                  N/A
                                </Typography>
                              )}
                            </TableCell>
                            <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                              <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                                {formatCurrency(transaction.amount_paid)}
                              </Typography>
                            </TableCell>
                            <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                              <Typography
                                variant="body2"
                                sx={{
                                  fontWeight: "bold",
                                  color: Number.parseFloat(transaction.balance_due) > 0 ? "error.main" : "success.main",
                                }}
                              >
                                {formatCurrency(transaction.balance_due)}
                              </Typography>
                            </TableCell>
                            <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                              <Tooltip title="View Order Details">
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    viewTransactionDetail(transaction)
                                  }}
                                >
                                  <Visibility />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                    </React.Fragment>
                  )}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50, 500, 1000]}
                component="div"
                count={filteredTransactions?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={(_, newPage) => setPage(newPage)}
                onRowsPerPageChange={(e) => {
                  setRowsPerPage(Number.parseInt(e.target.value, 50))
                  setPage(0)
                }}
              />
            </TableContainer>

            <Paper sx={{ p: 2, mt: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: "bold", color: "primary.main" }}>
                  Payment Method Totals
                </Typography>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  {filters.branchId && (
                    <Chip 
                      label={`Branch: ${branches.find(b => b.branch_id === filters.branchId)?.name || filters.branchId}`}
                      color="primary"
                      variant="outlined"
                      size="small"
                    />
                  )}
                  {filters.categoryId && (
                    <Chip 
                      label={`Category: ${categories.find(c => c.category_id === filters.categoryId)?.name || filters.categoryId}`}
                      color="secondary"
                      variant="outlined"
                      size="small"
                    />
                  )}
                </Box>
              </Box>
              <Grid container spacing={2}>
                {Object.entries(paymentMethodTotals).map(([method, total]) => (
                  <Grid item xs={6} md={2} key={method}>
                    <Card sx={{
                      border: "1px solid",
                      borderColor: "grey.200",
                      borderRadius: 2,
                      boxShadow: "none",
                      "&:hover": { boxShadow: "0 2px 8px rgba(0,0,0,0.1)" },
                    }}>
                      <CardContent>
                        <Typography variant="body2" color="text.secondary">
                          Total {method.charAt(0).toUpperCase() + method.slice(1)}
                        </Typography>
                        <Typography variant="h6" sx={{ fontWeight: "bold", color: "primary.dark" }}>
                          {formatCurrency(total)}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Paper>
          </Box>

          {/* Transaction Detail Dialog */}
          <Dialog 
            open={showTransactionDetail} 
            onClose={closeTransactionDetail} 
            maxWidth="md" 
            fullWidth
          >
            <DialogTitle>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6">
                  {loadingDetails ? "Loading Order Details..." : `Order Details - ${selectedTransaction?.order_code}`}
                </Typography>
                <IconButton onClick={closeTransactionDetail}>
                  <Close />
                </IconButton>
              </Box>
            </DialogTitle>
            
            {loadingDetails && <LinearProgress />}
            
            <DialogContent dividers>
              {loadingDetails ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 4 }}>
                  <CircularProgress />
                  <Typography sx={{ ml: 2 }}>Fetching order breakdown...</Typography>
                </Box>
              ) : detailsError ? (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3 }}>
                  <ErrorIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
                  <Typography color="error" gutterBottom>
                    Error Loading Details
                  </Typography>
                  <Typography variant="body2" color="text.secondary" align="center">
                    {detailsError}
                  </Typography>
                  <Button 
                    variant="outlined" 
                    onClick={() => selectedTransaction && fetchOrderDetails(selectedTransaction.order_id, selectedTransaction.branch_id || "")}
                    sx={{ mt: 2 }}
                  >
                    Retry
                  </Button>
                </Box>
              ) : orderDetails ? (
                <Grid container spacing={3}>
                  {/* Order Summary Section */}
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
                      Order Summary
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={6} md={3}>
                        <Typography variant="body2" color="text.secondary">Order ID</Typography>
                        <Typography variant="body1" fontWeight="bold">
                          {selectedTransaction?.order_id || orderDetails.items[0]?.order_id}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Typography variant="body2" color="text.secondary">Order Code</Typography>
                        <Typography variant="body1">
                          {selectedTransaction?.order_code || 'N/A'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Typography variant="body2" color="text.secondary">Customer</Typography>
                        <Typography variant="body1">
                          {selectedTransaction?.member_name || selectedTransaction?.firstName || 'N/A'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Typography variant="body2" color="text.secondary">Product Category</Typography>
                        <Typography variant="body1">
                          {selectedTransaction?.transaction_category ? 
                            categories.find(c => c.category_id === selectedTransaction.transaction_category)?.name || 
                            selectedTransaction.transaction_category : 
                            'N/A'}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    <Divider sx={{ my: 2 }} />
                  </Grid>

                  {/* Order Items Section */}
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
                      Order Items ({orderDetails.items.length})
                    </Typography>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Product Name</TableCell>
                          <TableCell align="right">Qty</TableCell>
                          <TableCell align="right">Unit Price</TableCell>
                          <TableCell align="right">Total</TableCell>
                          <TableCell>Status</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {orderDetails.items.map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>
                              <Typography fontWeight="medium">{item.name} - {item.description}</Typography>
                              <Typography variant="caption" color="text.secondary">
                                ID: {item.product_id}
                              </Typography>
                            </TableCell>
                            <TableCell align="right">
                              <Typography>{item.quantity}</Typography>
                            </TableCell>
                            <TableCell align="right">
                              <Typography>{formatCurrency(item.price)}</Typography>
                              <Typography variant="caption" color="text.secondary" display="block">
                                Cost: {formatCurrency(item.cost_price || 0)}
                              </Typography>
                            </TableCell>
                            <TableCell align="right" fontWeight="bold">
                              <Typography>{formatCurrency(item.total_amount)}</Typography>
                              {item.cost_price && (
                                <Typography variant="caption" color="success.main" display="block">
                                  Profit: {formatCurrency((item.quantity * parseFloat(item.price)) - (item.quantity * parseFloat(item.cost_price)))}
                                </Typography>
                              )}
                            </TableCell>
                            <TableCell>
                              <Chip 
                                label={item.status}
                                size="small"
                                color={item.status === 'COMPLETED' ? 'success' : 'default'}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                      <TableFooter>
                        <TableRow>
                          <TableCell colSpan={2}>
                            <Typography variant="subtitle1" fontWeight="bold">
                              Totals
                            </Typography>
                          </TableCell>
                          <TableCell align="right" colSpan={3}>
                            <Typography variant="subtitle1" fontWeight="bold">
                              {formatCurrency(
                                orderDetails.items.reduce((sum, item) => sum + parseFloat(item.total_amount), 0)
                              )}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              Total Quantity: {orderDetails.items.reduce((sum, item) => sum + parseFloat(item.quantity.toString()), 0)}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </Grid>

                  {/* Financial Summary Section */}
                  <Grid item xs={12}>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
                      Financial Summary
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Card variant="outlined">
                          <CardContent>
                            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                              Sales Totals
                            </Typography>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                              <Typography> Sales:</Typography>
                              <Typography fontWeight="bold">
                                {formatCurrency(
                                  orderDetails.items.reduce((sum, item) => sum + (parseFloat(item.quantity.toString()) * parseFloat(item.price)), 0)
                                )}
                              </Typography>
                            </Box>
                            <Divider sx={{ my: 1 }} />
                          </CardContent>
                        </Card>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Card variant="outlined">
                          <CardContent>
                            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                              Order Information
                            </Typography>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                              <Typography>Items Count:</Typography>
                              <Typography>{orderDetails.items.length}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                              <Typography>Payment Method:</Typography>
                              <Chip 
                                label={selectedTransaction?.mode_of_payment || 'N/A'}
                                size="small"
                                color="secondary"
                              />
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                              <Typography>Product Category:</Typography>
                              <Typography>
                                {selectedTransaction?.transaction_category ? 
                                  categories.find(c => c.category_id === selectedTransaction.transaction_category)?.name || 
                                  selectedTransaction.transaction_category : 
                                  'N/A'}
                              </Typography>
                            </Box>
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* Date Range Information */}
                  {orderDetails.date_range?.applied && (
                    <Grid item xs={12}>
                      <Divider sx={{ my: 2 }} />
                      <Alert severity="info" icon={<InfoIcon />}>
                        <Typography variant="body2">
                          <strong>Date Range Applied:</strong> Items filtered from {orderDetails.date_range.start_date} to {orderDetails.date_range.end_date}
                        </Typography>
                      </Alert>
                    </Grid>
                  )}

                  {/* Metadata Section */}
                  <Grid item xs={12}>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="caption" color="text.secondary">
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <InfoIcon fontSize="small" />
                        <Box>
                          <div>Fetched {orderDetails.items.length} items for Order ID: {selectedTransaction?.order_id}</div>
                          <div>Date Range: {filters.startDate ? formatDateYMD(filters.startDate) : 'N/A'} to {filters.endDate ? formatDateYMD(filters.endDate) : 'N/A'}</div>
                          {orderDetails.items[0]?.branch_id && (
                            <div>Branch ID: {orderDetails.items[0].branch_id.substring(0, 12)}...</div>
                          )}
                        </Box>
                      </Box>
                    </Typography>
                  </Grid>
                </Grid>
              ) : (
                <Typography color="text.secondary" align="center" sx={{ p: 3 }}>
                  No order details available
                </Typography>
              )}
            </DialogContent>
            
            <DialogActions>
              <Button onClick={closeTransactionDetail}>Close</Button>
            </DialogActions>
          </Dialog>

          <Snackbar
            open={snackbarOpen}
            autoHideDuration={3000}
            onClose={() => setSnackbarOpen(false)}
            message={snackbarMessage}
          />
        </IonContent>
      </IonPage>
    </LocalizationProvider>
  )
}

export default ManagerSalesReportPage_R